import React from "react";
import { Card, CardContent } from "../../../components/ui/card";
import { Toggle } from "../../../components/ui/toggle";
import { FolderSync, ListRestart } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../contexts/I18nProvider";
import {
  resetFilters,
  toggleSyncChapters,
} from "../../../redux/slices/filterSlice";
import { selectSyncChapters } from "../../../redux/selectors/filterSelectors";

function MiscallenousBar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const dispatchResetFilters = () => dispatch(resetFilters());
  const dispatchToggleSyncChapters = () => dispatch(toggleSyncChapters());

  const syncChapters = useSelector(selectSyncChapters);

  return (
    <Card className="max-w-full py-2 px-4 lg:px-6 lg:py-4 border-gray-200 bg-primary/20 lg:bg-primary/10 shadow-none">
      <CardContent className="flex gap-2 items-center mb-0 pb-0 px-0 ">
        <Toggle
          className="rounded-xl "
          variant="secondary"
          onPressedChange={dispatchResetFilters}
          aria-label="Toggle Sync Chapters"
        >
          <ListRestart /> {t('polyglot.resetFilters')}
        </Toggle>
        <Toggle
          className="rounded-xl "
          defaultPressed={!syncChapters}
          variant="primary"
          onPressedChange={dispatchToggleSyncChapters}
          aria-label="Toggle Sync Chapters"
        >
          <FolderSync /> {t('polyglot.syncChapters')}
        </Toggle>
      </CardContent>
    </Card>
  );
}

export default MiscallenousBar;
